import React, { useEffect, useState } from 'react';
import { Col, Form, Row, Spinner } from 'react-bootstrap';
import './style.scss';
import { useTranslation } from 'react-i18next';
import Currency, {currencyReverse} from 'helpers/Currency';
import { DollarCurrency } from 'helpers/Currency';
import { EuroCurrency } from 'helpers/Currency';

const FormSelectActions = ({
    list,
    selected,
    onChange,
    load,
    disabled,
    value_nf
}) => {
  const { t } = useTranslation();
  const top = React.createRef();
  const h_top = React.createRef();

  const bottom = React.createRef();
  const h_bottom = React.createRef();

  const [actionsS, setActionsS] = useState([]);

  const [total, setTotal] = useState(0);

  useEffect(()=>{
    function scroll(s,h){
      let element = s.current;
      let element_h = h.current;
      if( (element.offsetHeight < element.scrollHeight) || (element.offsetWidth < element.scrollWidth)){
        if(element_h.className.indexOf(' h-scroll')==-1)
        element_h.className += " h-scroll";
      }else{
        element_h.className = element_h.className.replace(' h-scroll','');
      }
    }
    try {
      scroll(top,h_top);
      scroll(bottom,h_bottom);
    } catch(error){}
    let t = 0;
    actionsS.forEach(a=>{
      if(a.value_d){
        if(a.currency_d == "1")
        t += a.value_d;
        else
        t += a.value_d*a.med_cotacao;
      }
    })
    setTotal(t);
  },[list, actionsS]);

  useEffect(()=>{
    if(selected){
      setActionsS([...selected.map(a=>{
        let r = a.action;
        r.value_d = a.value;
        r.action_name = r.name;
        r.company_alias = r.company.name;
        r.status_name = r.status.name;
        r.currency_d = a.currency?a.currency.toString():r.currency.toString();
        r.task_name = r.task.name;
        return r;
      })])
      setTotal(t);
    } else {
      setActionsS([]);
      if(onChange) onChange([]);
    }
  },[list,selected])

  const switchCurrencyType = (value, currencyId) => {
    let currencyType;

    if (!!value) {
      switch (currencyId) {
        case 1:
          currencyType = (
            parseFloat(value).toLocaleString('pt-BR',{style:'currency',currency:'BRL'})
          );
          break;
        case 2:
          currencyType = (
            parseFloat(value).toLocaleString('en',{style:'currency',currency:'USD'})
          );
          break;
        case 3:
          currencyType = (
            parseFloat(value).toLocaleString('eu',{style:'currency',currency:'EUR'})
          );
          break;
      }
    } else {
      currencyType = '--';
    }
    return currencyType;
  };

  const renderItems = () => {
    if(list.length === 0){
      return <div className="select-actions-item row justify-content-center">
        <Col xs="auto"> Lista vazia </Col>
      </div>
    }
    return list.filter((a)=>{
      return actionsS.map(b=>(b.id)).indexOf(a.id)==-1;
    }).map((v,k)=>{
      return <div key={k} className="select-actions-item row">
        <Col xs="auto" className="pl-1 pr-1 align-self-center"><input type="checkbox" checked={false} onChange={()=>{
          setActionsS([...actionsS, {
            ...v, 
            currency_d:`${v.currency}`
          }]);
          if(onChange) onChange([...actionsS, {
            ...v, 
            currency_d:`${v.currency}`
          }]);
        }}></input></Col>
        <Col className="align-self-center">{v.id}</Col>
        <Col className="align-self-center">{v.action_name}</Col>
        <Col className="align-self-center">{v.company_alias}</Col>
        <Col className="align-self-center">{switchCurrencyType(
            parseFloat(v.value?v.value:0),
            v.currency
          )}</Col>
        <Col className="align-self-center">{t('statuses:'+v.status_name)}</Col>
        <Col className="align-self-center">{v.task_name}</Col>
      </div>;
    })
  }

  const getCurrencyTag=(k,currency)=>{
    let item = actionsS[k];
    function changeValue(e){
      let value = currencyReverse(e.target.value)?currencyReverse(e.target.value):undefined
      setActionsS([...actionsS.map(a=>({...a,value_d:(a.id==item.id?value:a.value_d)}))]);
      if(onChange) onChange([...actionsS.map(a=>({...a,value_d:(a.id==item.id?value:a.value_d)}))]);
    }
    switch (currency) {
      case '1':
        return ( 
        <Currency
          className=""
          value={item.value_d}
          onChange={(e) => changeValue(e) }
          required
          size="sm"
          disabled={disabled}
        />);
        break;
      case '2':
        return ( 
        <DollarCurrency
          className=""
          value={item.value_d}
          onChange={(e) => changeValue(e) }
          required
          size="sm"
          disabled={disabled}
        />);
        break;
      case '3':
        return ( 
        <EuroCurrency
          className=""
          value={item.value_d}
          onChange={(e) => changeValue(e) }
          required
          size="sm"
          disabled={disabled}
        />);
        break;
    
      default:
        break;
    }
  };

  const getText = (value,currency,cotacao,currency_action) => {
    if(currency != "1"){
      let valor = (currency==='2'?'$ ':'€ ')+parseFloat(value.toFixed(2)).toLocaleString(currency==='2'?'en':'pt');
      let convertido = "R$ "+parseFloat((value*cotacao).toFixed(2)).toLocaleString('pt');
      return valor+' = '+convertido;
    } else {
      if(currency == currency_action) return "";
      let convertido = (currency_action==='2'?'$ ':'€ ')+parseFloat((value/cotacao).toFixed(2)).toLocaleString(currency==='2'?'en':'pt');
      let valor = "R$ "+parseFloat((value).toFixed(2)).toLocaleString('pt');
      return valor+' = '+convertido;
    }
  }

  const getListSelectCurrency = (currency) => {
    let retorno = [
      (<option value="1">R$</option>)
    ];
    if(currency === '2')
    retorno.push((<option value="2">$</option>))
    if(currency === '3')
    retorno.push((<option value="3">€</option>))
    
    return retorno;
  }

  const renderItemsSelected = () => {
    if(actionsS.length === 0){
      return <div className="select-actions-item row justify-content-center">
      <Col xs="auto"> Sem ações selecionadas </Col>
    </div>
    }
    return actionsS.map((v,k)=>{
      return <div key={k} className="select-actions-item row">
        {!disabled?(
          <Col xs="auto" className="pl-1 pr-1 align-self-center"><input type="checkbox" checked={true} onChange={()=>{
            setActionsS([...actionsS.filter(a=>(a.id != v.id))]);
            if(onChange) onChange([...actionsS.filter(a=>(a.id != v.id))]);
          }}></input></Col>
        ):''}
        <Col className="align-self-center">{v.id}</Col>
        <Col className="align-self-center">{v.action_name}</Col>
        <Col className="align-self-center">{v.company_alias}</Col>
        <Col className="align-self-center">{switchCurrencyType(
          parseFloat(v.value?v.value:0),
          v.currency
        )}</Col>
        <Col className="align-self-center">{t('statuses:'+v.status_name)}</Col>
        <Col className="align-self-center">{v.task_name}</Col>
        <Col xs="3" className="align-self-center">
          <div className="row pl-3 pr-3">
            <Col xs="auto" className="pl-0 pr-0">
              <Form.Control
                as="select"
                value={v.currency_d}
                size="sm"
                disabled={disabled}
                onChange={(e) => {
                  setActionsS([...actionsS.map(a=>({...a,currency_d:(a.id==v.id?`${e.target.value}`:a.currency_d)}))]);
                }}
              >
                {getListSelectCurrency(`${v.currency}`)}
                
              </Form.Control>  
            </Col>
            <Col className="pl-0 pr-0">
              {getCurrencyTag(k,v.currency_d)}
            </Col>
          </div>
          <Form.Text className="text-muted">
            {getText(
              v.value_d?v.value_d:0,
              v.currency_d,
              parseFloat(v.med_cotacao?v.med_cotacao:1),
              `${v.currency}`
            )}
          </Form.Text>
        </Col>
        <Col xs="1" className="align-self-center">{switchCurrencyType(
          parseFloat(v.med_cotacao?v.med_cotacao:1),
          1
        )}</Col>
      </div>;
    })
  }

  if(load){
    return <div className='area-select-actions'>
      <Row className="justify-content-center mt-2">
        <Col xs="auto" className="align-self-center">
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </Col>
      </Row>
    </div>;
  }

  const getValueMoney = value => {
    if(value){
      return parseFloat(value)?
      parseFloat(value).toLocaleString('pt',{style:'currency',currency:'BRL'}):
      value
    } else {
      return parseFloat(0).toLocaleString('pt',{style:'currency',currency:'BRL'});
    }
  }

  return <div className='area-select-actions'>
    {!disabled?(<>
      <div className="select-actions-head row" ref={h_top}>
        <Col xs="auto" className="p-1"><div style={{width:'13px'}}></div></Col>
        <Col>Nº Ação</Col>
        <Col>Nome</Col>
        <Col>Fabricante</Col>
        <Col>Valor</Col>
        <Col>Status</Col>
        <Col>Atividade</Col>
      </div>
      <div className='select-actions-top' ref={top}>
        {renderItems()}
      </div>
    </>):''}
    <div className='select-actions-center'>
      <Row className="h-100 m-0">
        <Col xs="auto" className="align-self-center">
          <b>Valor todal da NF:</b> {getValueMoney(value_nf)}
        </Col>
        <Col xs="auto" className="align-self-center">
          <b>Valor todal do rateio:</b> {getValueMoney(total)}
        </Col>
        {/* <Col xs="auto" className="align-self-center">
          {actionsS.length}/{list.length}
        </Col> */}
      </Row>
    </div>
    <div className="select-actions-head row" ref={h_bottom}>
      {!disabled?(
        <Col xs="auto" className="p-1"><div style={{width:'13px'}}></div></Col>
      ):''}      
      <Col>Nº Ação</Col>
      <Col>Nome</Col>
      <Col>Fabricante</Col>
      <Col>Valor</Col>
      <Col>Status</Col>
      <Col>Atividade</Col>
      <Col xs="3">Valor NF</Col>
      <Col xs="1">Cotação</Col>
    </div>
    <div className='select-actions-bottom' ref={bottom}>
      {renderItemsSelected()}
    </div>
  </div>
}

export default FormSelectActions;